import { ReactComponent as ArrowIcon } from '@packages/shared/assets/simple-registration/prevArrow.svg';
import IconButton, { IconButtonProps } from '../IconButton';

export type ArrowButtonProps = Exclude<IconButtonProps, 'children'>;

const ArrowButton = (props: ArrowButtonProps) => {
  return (
    <IconButton {...props}>
      <ArrowIcon />
    </IconButton>
  );
};

export default ArrowButton;
